var showMessage;

$(document).ready(function() {
	var $component = $('.GPC0142');
	if($component.length==0) return false;
	
	// gate
	if($component.find('.gate').length>0) {
		$component.find('.gate .list > li > a').on('mouseenter focus', function() {
			event.stopPropagation();
			$(this).closest('.gate').addClass('hover');
			$(this).closest('li').addClass('active').siblings().removeClass('active');
			$component.find('.for-gate.message > ul > li').eq($(this).closest('li').index()).addClass('active').siblings().removeClass('active');
		}).on('click', function() {
			event.preventDefault();
			var ww = $(window).width();
			if(ww<768) {
				$(this).parent().addClass('active').siblings().removeClass('active').closest('.gate').addClass('hover');
				$('html, body').stop().delay(100).animate({scrollTop: $(this).parent().offset().top}, 500);
			} else {
				var curationTitle = $(this).closest('li').find('a > .txt').text();
				trackEvent("intro:img_click", curationTitle);
				window.location.href=$(this).attr('href');
			}
		});
		$component.on('mouseleave', function() {
			event.stopPropagation();
			var ww = $(window).width();
			if(ww>=768) {
				$component.find('.for-gate.message ul li').removeClass('active');
				$component.find('.gate').removeClass('hover');
			}
		});
		$component.find('.gate .list > li > .message > .next-area > a').on('click', function() {
			var curationTitle = $(this).closest('li').find('a > .txt').text();
			trackEvent("intro:next", curationTitle);
		});
	}

	// step
	if($component.find('.step').length>0) {
		var currentFocus;
		var $step1 = $component.find('.step1');
		var $step2 = $component.find('.step2');
		var $resultForm = $('#categoryCurFilterForm');
		var $productList = $('#resultCurProductList');
		var url = $step1.data('curation-url');
		var cid = $step1.data('curation-id');
		var ajaxData;
		var $step1Templete = $step1.find('.message .list template').html();
		var $step2Templete = $step2.find('.message .list template').html();
		var $btnStep1Next = $('#curationStep1Next');
		var $btnGoBack = $('#goBack');
		var $btnStartOver = $('#curationStartOver');
		var $btnReset = $('#curationReset');
		var step1TitleArray = new Array();
		var hiddenMessage = $step1.find('.hidden-message');
		var currentStep = 0;
		var hmsg = new Array();
		var request = new Request(); //LGEGMC-2364 add
		
		$('#prevBtn').attr("href", document.referrer);
		
		//SNS Share URL ADD
		//LGEGMC-2364 START
		if(location.href.indexOf('?') > 0 && location.href.indexOf('curationResultId') > 0 && location.href.indexOf('curationId') > 0){
			$('.result-curation-sns .list .sns-inner .sns-share li a').attr("data-copy-url", location.host + location.pathname);
			$('.result-curation-sns .list .sns-inner .sns-share li a').attr("data-url", location.host + location.pathname);
		}else{
			$('.result-curation-sns .list .sns-inner .sns-share li a').attr("data-copy-url", location.href.toString());
			$('.result-curation-sns .list .sns-inner .sns-share li a').attr("data-url", location.href.toString());
		}
		//LGEGMC-2364 END
		$step1.find('.message .list template').remove();
		$step2.find('.message .list template').remove();
		// get hidden message
		if(hiddenMessage.length > 0) {
			hiddenMessage.find('li').each(function() {
				hmsg[$(this).attr('class')] = $(this).text();
			});
			//console.log(hmsg);
		}
		hiddenMessage.remove();
		var calcMessage = function(r) {
			return hmsg[r];
		};

		showMessage = function(count) {
			if(currentStep === 1) {
				var data = $step1.find('.message .list input').serialize();
				var r  = data.replace(/step1=/gi, '').replace(/&/gi, ','); // CX00001148,CX00001149,CX00001150
				if(!!calcMessage(r)) {
					var customBox = $step1.find('.message .result .custom');
					customBox.text(calcMessage(r));
					customBox.addClass('active').siblings().removeClass('active');
				} else if (!!calcMessage('TWO_OR_MORE')) {
					var customBox = $step1.find('.message .result .custom');
					customBox.text(calcMessage('TWO_OR_MORE'));
					customBox.addClass('active').siblings().removeClass('active');
				} else {
					var countBox = $step1.find('.message .result .count');
					countBox.addClass('active').siblings().removeClass('active');
				}
				$step1.find('.message .result .result-number').text(count);
				$step2.find('.message .result .result-number').text(count);
				$step2.find('.message .result .count').addClass('active').siblings().removeClass('active');
			} else {
				if(parseInt(count) > 0) {
					$step1.find('.message .result .result-number').text(count);
					$step2.find('.message .result .result-number').text(count);
					$step2.find('.message .result .count').addClass('active').siblings().removeClass('active');
					$step2.find('.message .next').addClass('active show');
					$step2.find('.message ul > li.zero').removeClass('active show');
				} else {
					$step2.find('.message .result .zero').addClass('active').siblings().removeClass('active');
					$step2.find('.message .next').removeClass('active show');
					$step2.find('.message ul > li.zero').addClass('active show');
				}
			}
		};

		// all list-box
		$('body').on('click', '.step .list-box .bg, .step .list-box .bg-hover', function() {
			//event.preventDefault();
			var input = $(this).parent().find('input[type=checkbox]');
			if(input.is(':checked')) {
				input.prop('checked', false);
			} else {
				input.prop('checked', true);
			}
			input.trigger('change');
		});
		$('body').on('click', '.products-info a.add-to-cart,.products-info a.where-to-buy', function(e) {
			var modelName = $(this).closest(".products-info").find(".sku").children("a").text().replace(/(\s*)/g, "");
			var classGubun = "";
			if (!$(this).hasClass("add-to-cart")) {
				classGubun = "where_to_buy";
			} else {
				if ($(this).hasClass("pre-order")) {
					classGubun = "pre-order";
				} else if ($(this).hasClass("in-buynow")) {
					classGubun = "in-buynow";
				} else {
					classGubun = "add_to_cart";
				}
			}
			var idx = $('.steppage > div.step').index($('.steppage > div.active'));
			trackEvent("step" + (idx + 1) + ":" + classGubun + ":" + modelName, getExampleMsg($component.find('.step.active').find('.message .list input')));
		});
		
		$('body').on('click', '.GPC0142 .GPC0007 .visual, .model-name > a, .sku > a, .rating span, .rating a', function(e) {
			var modelName = $(this).closest(".products-info").find(".sku").children("a").text().replace(/(\s*)/g, "");
			if (modelName == "") {
				modelName = $(this).siblings(".products-info").find(".sku").children("a").text().replace(/(\s*)/g, "");
			}
			var idx = $('.steppage > div.step').index($('.steppage > div.active'));
			trackEvent("step" + (idx + 1) + ":product_click:" + modelName, getExampleMsg($component.find('.step.active').find('.message .list input')));
		});

		var getStepAjaxOnce = function() {
			ajax.call(url, xssfilter({curationId: cid}), "json", function(res) {
				var data;
				if (res && res.data && (data = res.data instanceof Array ? res.data[0] : res.data), "success" == res.status && data) {
					// $step1.data('multiSelectFlag', data.multiSelectFlag); // data-multiSelectFlag
					ajaxData = data.questionList;
					//LGEGMC-2364 START
					if(location.href.indexOf('?') > 0 && location.href.indexOf('curationResultId') > 0 && location.href.indexOf('curationId') > 0){
						$resultForm.find('input[name=urlCheck]').val('Y');
						var curationId = request.getParameter("curationId");
						showSecondStep(curationId);
					} else {
						showFirstStep();
					}
					//LGEGMC-2364 END
					//showSecondStep('CX00001148,CX00001149,CX00001150'); // for test
				}
			}, null, "body");
		}

		var makeHTML = function(temp, exList, n) {
			var listHTML = '<ul>';
			for(var i=0; i<exList.length;i++) {
				step1TitleArray[exList[i].exampleId] = exList[i].exampleTitle;
				var desktopChk = false;
				var mobileChk = false;
				var check = false;
				if(exList[i].exampleDesktopImageChecked){
					if(exList[i].exampleDesktopImageChecked.indexOf('.mp4') > 0){
						desktopChk = true;
					}
				}
				if(exList[i].exampleMobileImageChecked){
					if(exList[i].exampleMobileImageChecked.indexOf('.mp4') > 0){
						mobileChk = true;
					}
				}
				//LGEGMC-2364 START
				var urlCheck = $resultForm.find('input[name=urlCheck]').val();
				if(location.href.indexOf('?') > 0 && location.href.indexOf('curationResultId') > 0 && location.href.indexOf('curationId') > 0 && urlCheck == 'Y'){
					var paramArr = request.getParameter("curationResultId").replaceAll('2_','').split(",");
					for(var j=0; j<paramArr.length; j++){
						if(exList[i].exampleId == paramArr[j]){
							check = true;
						}
					}
				}
				//LGEGMC-2364 END
				var html = temp.replace(/\*num\*/gi, i)
								.replace(/\*num2\*/gi, n)
								.replace(/\*exampleId\*/gi, exList[i].exampleId)
                                                                 .replace(/\*structureType\*/gi, exList[i].structureType) //LGEGMC-2218
								.replace(/\*exampleDesktopImage\*/gi, (!exList[i].exampleDesc) ? '<img src="'+exList[i].exampleDesktopImage+'" class="lazyload pc icon-only" alt="" />' : '<img src="'+exList[i].exampleDesktopImage+'" class="lazyload pc" alt="" />')
								.replace(/\*exampleDesktopImageChecked\*/gi, (desktopChk) ? '<video class="desktop-only" muted playsinline id="'+exList[i].exampleId+'Desktop"><source src="'+exList[i].exampleDesktopImageChecked+'" type="video/mp4"></video>' : '<img src="'+exList[i].exampleDesktopImageChecked+'" class="lazyload pc" alt="" />')
								.replace(/\*exampleMobileImage\*/gi, (!exList[i].exampleDesc) ? '<img src="'+exList[i].exampleMobileImage+'" class="lazyload mobile icon-only" alt="" />' : '<img src="'+exList[i].exampleMobileImage+'" class="lazyload mobile" alt="" />')
								.replace(/\*exampleMobileImageChecked\*/gi, (mobileChk) ? '<video class="mobile-only" muted playsinline id="'+exList[i].exampleId+'Mobile"><source src="'+exList[i].exampleMobileImageChecked+'" type="video/mp4"></video>' : '<img src="'+exList[i].exampleMobileImageChecked+'" class="lazyload mobile" alt="" />')
								.replace(/\*exampleTitle\*/gi, exList[i].exampleTitle)
								.replace(/\*exampleTitleChecked\*/gi, exList[i].exampleTitleChecked ? exList[i].exampleTitleChecked : '')
								.replace(/\*exampleDesc\*/gi, exList[i].exampleDesc ? exList[i].exampleDesc : '')
								.replace(/\*exampleTitleColor\*/gi, exList[i].exampleTitleColor ? exList[i].exampleTitleColor : 'black')
								.replace(/\*exampleTitleColorChecked\*/gi, exList[i].exampleTitleColorChecked ? exList[i].exampleTitleColorChecked : 'black')
								//LGEGMC-2364 START
								.replace(/\*checked\*/gi, check ? 'checked' : '')
								.replace(/\*hover\*/gi, check ? 'hover' : '')
								//LGEGMC-2364 END
								;
				listHTML = listHTML + '<li>' + html + '</li>';
			}
			listHTML = listHTML + '</ul>';
			return listHTML;
		}

		var initStep = function() {
			$step2.removeClass('active');
			$step2.find('.message ul li').not('.icon').removeClass('active show');
			$step2.find('.message .result .count-message .count').addClass('active').siblings().removeClass('active');
			$step2.find('.message .list .sublist').remove();
			$step1.removeClass('active');
			$step1.find('.message ul li').not('.icon').removeClass('active show');
			$step1.find('.message .result .count-message .count').addClass('active').siblings().removeClass('active');
			$step1.find('.message .list > ul').remove();
			$btnStep1Next.attr('disabled', true);
			$('.result-curation-box').removeAttr('style');
			$('html, body').scrollTop(0);
			$resultForm.find('input[name=curationResultId]').val(''); //result 아이디 초기화
			//LGEGMC-2364 START
			$('.result-curation-sns .list .sns-inner .sns-share li a').attr("data-copy-url", location.host + location.pathname);
			$('.result-curation-sns .list .sns-inner .sns-share li a').attr("data-url", location.host + location.pathname);
			//LGEGMC-2364 END
			showFirstStep();
		};

		var showFirstStep = function() {
			currentStep = 1;

			var $stepList = $step1.find('.message .list');
			var $stepResult = $step1.find('.message .result');
			var $stepNext = $step1.find('.message .next');
			var $stepBtns = $step1.find('.message .btn-area');

			// get result list
			$resultForm.find('input[name=curationId]').val(cid);
			$resultForm.submit();

			// make html (step1)
			$step1.addClass('active');
			$stepList.append(makeHTML($step1Templete, ajaxData[0].exampleList, 0));
			
			// add event
			var $inputs = $step1.find('.message .list input');
			$inputs.off('change.step1').on('change.step1', function() {
				event.preventDefault();
				currentFocus = $(this);
				var sc = $(window).scrollTop();

				var checked = $(this).is(':checked');
				if(checked) {
					$(this).closest('.list-box').addClass('hover');
					var video = document.getElementById($(this).closest('.list-box').find('.bg-hover video:visible').attr('id'));
					if($(video).length>0) {
						video.play();
					}
				} else {
					$(this).closest('.list-box').removeClass('hover');
					var video = document.getElementById($(this).closest('.list-box').find('.bg-hover video:visible').attr('id'));
					if($(video).length>0) {
						if(!video.ended) video.pause();
					} else {
						var img = $(this).closest('.list-box').find('.bg-hover img');
						var file = img.attr('src');
						if(file.indexOf('.gif') >= 0) {
							img.attr('src', file);
						}
					}
				}

				// get checkbox list
				//LGEGMC-2364 START
				var data = $inputs.serialize();
				var r  = data.replace(/step1=/gi, '').replace(/&/gi, ','); // CX00001148,CX00001149,CX00001150
				var url = location.host + location.pathname;
				if(data.length === 0) {
					$btnStep1Next.attr('disabled', true);
					$('.result-curation-sns .list .sns-inner .sns-share li a').attr("data-copy-url", url);
					$('.result-curation-sns .list .sns-inner .sns-share li a').attr("data-url", url);
				} else {
					$btnStep1Next.attr('disabled', false);
					$('.result-curation-sns .list .sns-inner .sns-share li a').attr("data-copy-url", url+"?curationId="+r);
					$('.result-curation-sns .list .sns-inner .sns-share li a').attr("data-url", url+"?curationId="+r);
				}
				//LGEGMC-2364 END

				// show the custom text
				var hiddenTxt = calcMessage(r);
				if(!!hiddenTxt) {
					var custom = $stepResult.find('.count-message .custom');
					custom.text(hiddenTxt);
					custom.addClass('active').siblings().removeClass('active');
				} else {
					var custom = $stepResult.find('.count-message .custom');
					var count = $stepResult.find('.count-message .count');
					count.addClass('active').siblings().removeClass('active');
				}

				// get product list
				$resultForm.find('input[name=curationId]').val(cid);
				$resultForm.find('input[name=curationResultId]').val('');
				$resultForm.submit();
				
				var exampleTitle = "";
				exampleTitle = $(this).attr('aria-label');
				if(checked) {
					trackEvent("step1:ex_click", exampleTitle);
				}else{
					trackEvent("step1:ex_un-click", exampleTitle);
				}
				
				$('html, body').scrollTop(sc);
			});
			$btnStep1Next.off('click.step1').on('click.step1', function() {
				var data = $inputs.serialize();
				var r  = data.replace(/step1=/gi, '').replace(/&/gi, ',');// CX00001148,CX00001149,CX00001150
				showSecondStep(r);
				trackEvent("step1", getExampleMsg($inputs));
				$('.result-curation-box').removeAttr('style');
			});
			$('.step1 .btn-area > a').off('click').on('click', function() {
				trackEvent("step1:prev", getExampleMsg($inputs));
			});
			// show (animate)
			// -- active - display: block, opacity: 0;
			// -- show - opacity: 1;
			var time = 1000;
			var time2 = 200;
			setTimeout(function() {
				$stepList.addClass('active');
				setTimeout(function() {
					$stepList.addClass('show');
					setTimeout(function() {
						$stepResult.addClass('active');
						setTimeout(function() {
							$stepResult.addClass('show');
							$('.result-curation-box').css('height', 'auto');
							$stepNext.addClass('active');
							setTimeout(function() {
								$stepNext.addClass('show');
								$stepBtns.addClass('active');
								setTimeout(function() {
									$stepBtns.addClass('show');
								}, time/2);
							}, time/2);
						}, time);
					}, time);
				}, time2);
			}, time);
		};

		var showSecondStep = function(data) {
			currentStep = 2;

			$step1.removeClass('active');
			$step2.addClass('active');
			window.scrollTo(0,0); //LGEGMC-1923 add
			var $stepList = $step2.find('.message .list');
			var $stepResult = $step2.find('.message .result');
			var $stepNext = $step2.find('.message .next');
			var $stepBtns = $step2.find('.message .btn-area');
			var category = data;
			var curationCheck = "", 
				urlCheck = $resultForm.find('input[name=urlCheck]').val(); //LGEGMC-2364 add
			
			// make html (step2)
			for(var i=1;i<ajaxData.length;i++) {
				//console.log(ajaxData[i]);
				if(category.indexOf(ajaxData[i].highLevelExampleId) >= 0) {
					var html = '<div class="sublist"><div class="subtitle">'+(step1TitleArray[ajaxData[i].highLevelExampleId] ? step1TitleArray[ajaxData[i].highLevelExampleId] : '')+'</div>';
					html = html + makeHTML($step2Templete, ajaxData[i].exampleList, i);
					html = html + '</div>';
					$stepList.append(html);
				}
			}

			// add event
			var $inputs = $step2.find('.message .list input');
			$inputs.off('change.step2').on('change.step2', function() {
				event.preventDefault();
				var sc = $(window).scrollTop();
				currentFocus = $(this);

				var checked = $(this).is(':checked');
				if(checked) {
					$(this).closest('.list-box').addClass('hover');
				} else {
					$(this).closest('.list-box').removeClass('hover');
				}
				
				// get product list
				// LGEGMC-2218 Start
                                var resultData = $step2.find('.message .list .list-box.hover input');
				var resultCurIdCnt = resultData.length;
				var tmpResultCurId = [];
				var resultStepNo = $(".step.active").find(".indicator").find("li.active").text();
				var tempResult = "";
				if(resultCurIdCnt > 0) {
					resultData.each(function (idx) {
						var resultStructureType = $(this).attr("data-structure-type");
						var resultExampleId = $(this).val();
						console.log(resultExampleId)
						if(resultStructureType == "U") {
							resultCurationId = resultStepNo + "_" + resultExampleId;
						} else {
							resultCurationId = resultExampleId;
						}
		                tempResult += resultCurationId + ",";
		            });
					tmpResultCurId = tempResult.substr(0, tempResult.length - 1).split(",");
				}
				//var r  = $inputs.serialize().replace(/step2=/gi, '').replace(/&/gi, ','); // CX00001148,CX00001149,CX00001150
                
				// LGEGMC-2218 Start
				var r = tmpResultCurId;
				if(r != ""){
					$resultForm.find('input[name=curationId]').val('');
					$resultForm.find('input[name=curationResultId]').val(r);
				}else{
					$resultForm.find('input[name=curationId]').val(cid);
					$resultForm.find('input[name=curationResultId]').val('');
				}
				$resultForm.submit();
				
				//LGEGMC-2364 START
				var resultData = $inputs.serialize();
				if(urlCheck == 'Y') curationCheck = "?curationId="+data;
				var url = $('.result-curation-sns .list .sns-inner .sns-share li a').attr("data-url")+curationCheck;
				if(resultData.length === 0) {
					$('.result-curation-sns .list .sns-inner .sns-share li a').attr("data-copy-url", url);
				} else {
					$('.result-curation-sns .list .sns-inner .sns-share li a').attr("data-copy-url", url+"&curationResultId="+r);
				}
				//LGEGMC-2364 END
				
				var exampleTitle = "";
				exampleTitle = $(this).attr('aria-label');
				if(checked) {
					trackEvent("step2:ex_click", exampleTitle);
				}else{
					trackEvent("step2:ex_un-click", exampleTitle);
				}
				$('html, body').scrollTop(sc);
			});
			$btnGoBack.off('click.step2').on('click.step2', function() {
				event.preventDefault();
				//LGEGMC-2364 START
				$resultForm.find('input[name=urlCheck]').val('N');
				//LGEGMC-2364 END
				trackEvent("step2:prev", getExampleMsg($inputs));
				initStep();
			});
			
			//LGEGMC-1923_1 start
			var ref = document.referrer;
			var refVal = document.referrer.split(window.location.hostname)[1];
			var startOverUrl = $('#startOverBtnUrl').val();
			if(ref != "" && refVal == startOverUrl){
				$('.btn-start-over').remove();
				var $startOver = $('<a href="'+startOverUrl+'" id="prevBtn" class="btn btn-start-over" target="_self" >Start Over</a>');
				$('.GPC0142').find('.step2').find('.message .btn-area').append($startOver);
			}else{
				$btnStartOver.off('click.step2').on('click.step2', function() {
					event.preventDefault();
					//LGEGMC-2364 START
					$resultForm.find('input[name=urlCheck]').val('N');
					//LGEGMC-2364 END
					trackEvent("step2:startOver", getExampleMsg($inputs));
					initStep();
				});
			}
			//LGEGMC-1923_1 end
			
			$btnReset.off('click.step2').on('click.step2', function() {
				event.preventDefault();
				//LGEGMC-2364 START
				$resultForm.find('input[name=urlCheck]').val('N');
				//LGEGMC-2364 END
				trackEvent("step2:reset", getExampleMsg($inputs));
				initStep();
			});
			
			// LGEGMC-2326 Start
			$('.step2 .btn-area #curationStepGoList').off('click').on('click', function() {
				var listScrollTop = $('.result-curation-box').offset().top;
				 $("html, body").animate({ scrollTop: listScrollTop }, 300);
			});
			// LGEGMC-2326 End
			
			// show (animate)
			// -- active - display: block, opacity: 0;
			// -- show - opacity: 1;
			var time = 1000;
			var time2 = 200;
			setTimeout(function() {
				$stepList.addClass('active');
				setTimeout(function() {
					$stepList.addClass('show');
					setTimeout(function() {
						$stepResult.addClass('active');
						setTimeout(function() {
							$stepResult.addClass('show');
							$('.result-curation-box').css('height', 'auto');
							//LGEGMC-2364 START
							var zeroCheck = ($step2.find('.message ul > li.zero.active.show').length > 0 && urlCheck == 'Y');
							if(zeroCheck){
								$stepNext.removeClass('active');
							}else{
								$stepNext.addClass('active');
							}
							setTimeout(function() {
								if(zeroCheck){
									$stepNext.removeClass('show');
								}else{
									$stepNext.addClass('show');
								}
								//LGEGMC-2364 END
								$stepBtns.addClass('active');
								setTimeout(function() {
									$stepBtns.addClass('show');
								}, time/2);
							}, time/2);
						}, time);
					}, time);
				}, time2);
			}, time);
		};

		getStepAjaxOnce();

		// result
		var $typeBtn = $('.btn-listChange');
		var $productListBox = $(".product-list-box");
		var $thunbmailCarousel = $('.thumbnail-carousel');
		function resultChangeListBtnEvent() {
			$typeBtn.off('click').on('click' ,function(){
				$typeBtn.toggleClass("act");
				if($typeBtn.hasClass('act')){
					$productListBox.addClass('rows');
					$typeBtn.attr("data-sc-item", "plp_btn_list_change_to_2");
				}else{
					$productListBox.removeClass('rows');
					$typeBtn.attr("data-sc-item", "plp_btn_list_change_to_1");
				};
				if($thunbmailCarousel.hasClass('slick-initialized')){
					$thunbmailCarousel.slick('unslick');
					$thunbmailCarousel.slick({
						arrows: false,
						dots: true
					});
				} else{
					$thunbmailCarousel.slick({
						arrows: false,
						dots: true
					});
				}
				var winW = $(window).width();
				if(winW < 769 && $productListBox.hasClass('rows')){
					var _this = $('.model-buy');
					$.each(_this, function (i) {
						if(_this.eq(i).find(".price-area").css('height') === "0px" && _this.eq(i).find(".price-vip-Installment").css('height') === "0px" && _this.eq(i).find(".stock-area").css('height') === "0px"){
							$(this).hide();
						} else{
							if(_this.eq(i).find(".promotion-text").length == 0 && _this.eq(i).find(".promotion-text").css('height') === "0px") {
								$(this).hide();
							} else {
								$(this).show();
							}
						}
					})
				} else{
					$(".model-buy").show();
				}
			});
		}

		resultChangeListBtnEvent();
	}
});

function trackEvent(stepNo, exampleTitle) {
	var	curationTitle = $('.GPC0142 .title-wrap .title').text();
	adobeTrackEvent('curation-step-click', {curation_module : "curation", curation_item : curationTitle, curation_step : stepNo, curation_select : exampleTitle, page_event : {curation_step_click : true}});
}

function getExampleMsg(inputs){
	var d = [];
	$(inputs).each(function(i) {
		if($(this).is(':checked')){				   
			d[d.length] = $(this).attr('aria-label');
		}
	});
	return d.join();
}

//LGEGMC-2364 START
function Request(){
    var requestParam ="";
	 
	this.getParameter = function(param){
        var url = unescape(location.href);
        var paramArr = (url.substring(url.indexOf("?")+1,url.length)).split("&");
        
        for(var i = 0 ; i < paramArr.length ; i++){
           var temp = paramArr[i].split("="); //파라미터 변수명을 담음
        
           if(temp[0].toUpperCase() == param.toUpperCase()){
             requestParam = paramArr[i].split("=")[1];
             break;
           }
        }
        return requestParam;
    }
}
//LGEGMC-2364 END